import { LANG, switchLang } from "@/lib/i18n";

const OPTIONS = [["en", "English"], ["de", "Deutsch"], ["fr", "Français"], ["es", "Español"]];

export const LangToggle = () => (
  <div data-no-translate data-testid="lang-toggle" className="flex shrink-0 items-center rounded-full border border-white/20 p-0.5 font-mono text-[11px] uppercase">
    {OPTIONS.map(([code, name]) => (
      <button key={code} type="button" onClick={() => switchLang(code)} data-testid={`lang-${code}`} aria-pressed={LANG === code} aria-label={name}
        className={`rounded-full px-2 py-1.5 uppercase tracking-[0.08em] transition-colors duration-300 ${LANG === code ? "bg-white text-[#0B0716]" : "text-slate-300 hover:text-white"}`}>
        {code}
      </button>
    ))}
  </div>
);
